import React, { forwardRef } from 'react';
import { Search, X } from 'lucide-react';

export interface SearchInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  wrapperClassName?: string;
  onClear?: () => void;
  iconSize?: number;
}

/**
 * Standard search field — icon, clear button, and Vercel-style focus via `.filter-control`.
 */
export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className = '', wrapperClassName = '', value, onClear, iconSize = 18, ...props }, ref) => {
    const hasValue = value != null && String(value).length > 0;
    const showClear = hasValue && onClear;

    return (
      <div className={`relative ${wrapperClassName || 'w-full'}`}>
        <Search
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-content-muted"
          size={iconSize}
          aria-hidden
        />
        <input
          ref={ref}
          type="search"
          value={value}
          className={`filter-control w-full pl-10 ${showClear ? 'pr-10' : 'pr-3'} ${className}`}
          {...props}
        />
        {showClear && (
          <button
            type="button"
            onClick={onClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-content-muted transition-colors duration-200 hover:text-content-primary"
            aria-label="Clear search"
          >
            <X size={iconSize} />
          </button>
        )}
      </div>
    );
  }
);

SearchInput.displayName = 'SearchInput';
